<template>
  <div class="l-edit-dialog-box">
      <div class="l-table-place">
          <div class="flex flex-warp">
            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">编码</p>
              <el-input
                placeholder="请输入编码"
                v-model="search_data.material_code"
                class="input-with-select"
                style="width: 80%;"
              >
                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
              </el-input>
            </div>
            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">名称</p>
              <el-input
                placeholder="请输入名称"
                v-model="search_data.name"
                class="input-with-select"
                style="width: 80%;"
              >
                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
              </el-input>
            </div>
            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">分类名</p>
              <el-cascader v-model="search_data.type_id" :options="type_node" :props="{ checkStrictly: true }" clearable style="width:600px;"/>
              </el-cascader>
              <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </div>
            
            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">器材状态</p>
              <el-select v-model="search_data.material_state_id" placeholder="请选择器材状态" clearable  style="width:70%">
                <el-option v-for="item in material_state_list" style="width:80%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click="onSearch" style="width:20%"></el-button>
            </div>
      
          </div>     
      </div> 
    <!-- <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <el-col :span="24">
          <el-form-item label="器材分类" prop="type_id">
              <el-cascader v-model="form_data.type_id" :options="tree_node" :props="{ checkStrictly: true }" @change="changeMaterialType(form_data.type_id)" clearable>
              </el-cascader>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="器材名称" prop="material_name">
            <el-select v-model="form_data.material_name" placeholder="请选择器材名称" @change="changeMaterial(form_data.material_name)" clearable>
              <el-option v-for="item in material_list" style="width:50%" :key="item.id" :label="item.name" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="型号规格" prop="specification_id">
              <el-select v-model="form_data.specification_id" placeholder="请选择型号规格(如有)" @change="changeSpecification(form_data.material_name,form_data.specification_id)" clearable>
                <el-option v-for="item in specification_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        
       <el-col :span="12">
          <el-form-item label="出厂日期" prop="producted_at">
              <el-date-picker v-model="form_data.producted_at" type="date" autocomplete="off" clearable
                value-format="yyyy-MM-dd" placeholder="请选择出厂时间" />
          </el-form-item>
          
        </el-col>
        
        <el-col :span="6">
          <el-form-item label="投放数量" prop="material_quantity">
            <el-input v-model="form_data.material_quantity" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="6">
          <el-form-item label="库存单位" prop="material_sku_id">
              <el-select v-model="form_data.material_sku_id" placeholder="请选择库存单位" clearable>
                <el-option v-for="item in material_sku_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
          </el-form-item>
        </el-col>

      </el-row>

    </el-form> -->
    <div>
        <l-auth-button type="primary" auth="cabinet_detail_add_btn" @click="add_visible = true"> 新增</l-auth-button>
      <!-- <el-button @click="cancel">返 回</el-button> -->
      <!-- <l-auth-button type="primary" auth="cabinet_detail_add_btn" @click="handleSubmit" :loading="submitting">添 加</l-auth-button> -->
    </div>
    
    <l-table :data="data" v-loading="loading" row-key="id">
      
      <el-table-column prop="material_name" label="名称" min-width="200"> </el-table-column>
      <el-table-column prop="specification_name" label="规格" min-width="80"> </el-table-column>
    
      <el-table-column prop="producted_at" label="出厂日期" min-width="80"> 
        <template slot-scope="{ row }">
            <el-date-picker v-model="row.producted_at" type="date" autocomplete="off" clearable
                placement="bottom-start"
                value-format="yyyy-MM-dd" placeholder="请选择出厂时间" 
                v-show="row.show" />
            <span v-show="!row.show">{{row.producted_at.substring(0,10)}}</span>
        </template>
      </el-table-column>
        
      <el-table-column prop="material_quantity" label="数量" min-width="80"> 
        <template slot-scope="{ row }">
            <el-input-number v-model="row.material_quantity" size="small" :min="0" autocomplete="off" placeholder="请输入数量" 
                v-show="row.show" />
            <span v-show="!row.show">{{parseInt(row.material_quantity)}}</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="material_sku_name" label="库存单位" min-width="80"> </el-table-column>
      <el-table-column prop="material_state_name" label="器材状态" min-width="80"> </el-table-column>
      
      <!-- <el-table-column prop="created_at" label="创建时间" width="180"> </el-table-column> -->
      <el-table-column fixed="right" label="操作" width="350" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="cabinet_detail_edit_btn" @click="edit(row,'edit')" v-show="!row.show">
              <i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <l-auth-text-button type="primary" auth="cabinet_detail_edit_btn" @click="edit(row,'save')" v-show="row.show">
              <i class="el-icon-edit"></i>保存</l-auth-text-button>
          <l-auth-text-button type="primary" auth="cabinet_detail_edit_btn" @click="edit(row,'cancel')" v-show="row.show">
              <i class="el-icon-edit"></i>取消</l-auth-text-button>
          <!-- <el-button @click="row.show=false">保存</el-button> -->
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="cabinet_detail_del_btn" @click="del(row.id)">
              <i class="el-icon-delete"></i>删除</l-auth-text-button>
        </template>
      </el-table-column>

    </l-table>
    
    <!--添加模板柜物资-->
    <l-dialog :visible.sync="add_visible" title="添加消防柜物资" width="1000px">
      <l-material-add @on-success="onAddSucess" :visible.sync="add_visible" :id="this.$props.id"></l-material-add>
    </l-dialog>
  </div>

    

</template>

<script>
// import {
//   types
// } from './lavel.js';
// console.log(types)
import CabinetMaterialAdd from "./MaterialAdd.vue";
export default {
  name: 'l-material-list',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    // place_type: {
    //   type: [String, Number],
    //   default: null
    // },
    material_type: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    },
  },

  components: {
      [CabinetMaterialAdd.name]: CabinetMaterialAdd,
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
    // place_type_list() {
    //   return this.$store.state.list.place_type_list
    // }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();

        }
      }
    },
    // "form_data.is_node"(val){
    //   if(val!=0){
    //     this.form_data.pid=""
    //   }
    // },
    // "form_data.pid"() {
    //   if (!this.getdata_flag) {
    //     this.form_data.type = ""
    //   } else {
    //     this.getdata_flag = false
    //   }
    //   this.changes();
    // }
  },
  data() {
    return {
        data: [],
        count: 0,
      loading: false,//页面是否加载中
      getdata_flag: false,
      // LAVEL_LIST: types,
      //是否显示
      type_node: [

      ],
      material_sku_list: [],
      material_state_list: [],
      //表单数据
      form_data: {
        // is_node: 0,
        // pid: "",
        material_name: '',
        material_code: '',
        // department_level: '',
        abbreviation: '',
        // place_type: '',
        // is_public: 1,
      },
      nodeList: [],
      material_list: [],
      specification_list: [],
      //分类
      sel_type_id: "",
      type_name: "",
      material_id: 0,
        add_visible: false, //是否显示添加
        search_data: {
          keywords: "",
          material_code: "",
          name: "",
          type_id: [],
        },
      //表单验证规则
      rules: {
        type_id: [
          { required: true, message: '器材分类不能为空', trigger: 'change' }
        ],  
        material_name: [
          { required: true, message: '器材名称不能为空', trigger: 'change' }
        ],
        material_quantity: [
          { required: true, message: '投放数量不能为空', trigger: 'change' }
        ],
        producted_at: [
          { required: true, message: '出厂日期不能为空', trigger: 'change' }
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  mounted() {

  },


  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    func_click(e) {
      if (this.form_data.type == '' && e) {
        this.$alert('请先选择等级', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    // changes() {
    //   this.$_invoke("industry_getData", {
    //     type: this.form_data.type
    //   }).then((ret) => {  
    //     this.nodeList = ret.data
    //   })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    
    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },
    
    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },
    
    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },
    
    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getData();
    },

    //获取数据
    getData() {
//       this.$_invoke(`cabinetTemplate_saveData`, ).then((ret) => {
// console.log(ret);
//         this.tree_node = ret.tree_node;
//       }).finally(() => {
//         this.loading = false;
//       });
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`cabinetManage_getMaterialList`, { id: this.$props.id }).then((ret) => {
            this.data = ret.data;
            this.count = ret.count;
          // this.form_data = ret.data;
          this.type_node = ret.type_node;
          this.material_sku_list = ret.material_sku_list;
          this.material_state_list = ret.material_state_list;
          this.getdata_flag = true;
          
          // this.data.forEach(element => {
          //     element["show"] = false;
          // })
          
        }).finally(() => {
          this.loading = false;
        });
      } else {
        // this.form_data.use_type = this.$props.useType
      }

    },

    changeMaterialType(typeid) {
        console.log(typeid);
        let sel_type_id = typeid
        if (typeof sel_type_id != "number") {
          const pid_len = sel_type_id.length;
          sel_type_id = sel_type_id[pid_len - 1];
        }
        
        this.loading = true;
        this.$_invoke(`cabinetManage_getMaterialListByTypeId`, {sel_type_id }).then((ret) => {
            this.material_list = ret.material_list;
        }).finally(() => {
          this.loading = false;
        });
    },
    
    changeMaterial(materialname) {
        console.log(materialname);
        let sel_material_name = materialname
        
        this.loading = true;
        this.$_invoke(`cabinetManage_getSpecificationListByMaterialName`, {sel_material_name }).then((ret) => {
            this.specification_list = ret.specification_list;
        }).finally(() => {
          this.loading = false;
        });
    },

    changeSpecification(materialname,specificationid) {
        let sel_material_name = materialname
        let sel_specification_id = specificationid
        this.loading = true;
        this.$_invoke(`cabinetManage_getMaterialIdByMaterialNSpecification`, {sel_material_name,sel_specification_id })
            .then((ret) => {
                this.material_id = ret.material_id;
            })
            .finally(() => {
                this.loading = false;
            });
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {

        if (valid) {
          // let form_data = Object.assign({}, this.form_data);
          // if (typeof form_data.pid != "number") {
          //   const pid_len = form_data.pid.length;
          //   form_data.pid = form_data.pid[pid_len - 1];
          // }
          this.submitting = true;
          // this.form_data.place_type = 3;
          if (this.hasId) {//添加
            this.$_invoke('cabinetManage_saveMaterial', {
                material_id: this.material_id,
                id: this.$props.id,
                ...this.form_data}).then(() => {
              this.$_msg.success('添加消防器材成功');
              this.getData();
            }).finally(() => {
              this.submitting = false;
            })
          } else {//修改
            
          }
        }
      })

    },
    
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`cabinetManage_deleteMaterialStock`, { id }).then((ret) => {
            if (ret != true) {
                this.$_msg.success("删除失败");
            } else {
                this.$_msg.success("删除成功");
                this.getData();
            }
          });
        })
        .catch(() => { });
    },
    
    //编辑/保存，改变状态
    edit(row, mode) {
        console.log(row.show);
        if (mode == "edit") {
            row.show = true;
        } else {
            row.show = false;
        }

        //save
        if (mode == "save") {
            this.submitting = true;
            if (this.hasId) {
                this.$_invoke('cabinetManage_updateMaterial', {id: row.id, 
                                                                material_quantity: row.material_quantity, 
                                                                producted_at: row.producted_at})
                    .then(() => {
                this.$_msg.success('修改消防器材成功');
                this.getData();
              }).finally(() => {
                this.submitting = false;
              })
            }
        }
    }
    
  },
}
</script>